import {Directive, ElementRef, Input, OnInit} from "@angular/core";
import {AbsoluteValue} from "../util/AbsoluteValue";

@Directive({selector: '[sxRadius]', standalone: false})
export class RadiusDirective implements OnInit {

  @Input() sxRadius: 'xSmall' | 'small' | 'medium' | 'large' | string;

  static readonly themeValues = {
    xSmall : "0.3125rem",
    small: "0.75rem",
    medium: "1.125rem",
    large: "1.375rem"
  }


  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    try {
      this.el.nativeElement.style.overflow = 'hidden'
      this.el.nativeElement.style.borderRadius = AbsoluteValue.getSplitValues(this.sxRadius, RadiusDirective.themeValues);
    } catch (e) {
      console.error("SX RADIUS PROPERTY", e)
    }
  }


}
